(function () {
  'use strict';
  var fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function money(v) { var n = parseFloat(v); return isNaN(n) ? '' : fmt.format(n > 1000 && String(v).indexOf('.') === -1 ? n / 100 : n); }
  function small(src, w) { return src ? src.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2') : ''; }

  /* ---------- Recherche instantanée avec photos ---------- */
  document.querySelectorAll('form.search').forEach(function (form) {
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    var panel = document.createElement('div');
    panel.className = 'qs'; panel.id = 'qs-' + Math.random().toString(36).slice(2, 7);
    panel.innerHTML = '<div class="qs__load"></div><div class="qs__body"></div>';
    form.appendChild(panel);
    input.setAttribute('aria-controls', panel.id);
    input.setAttribute('aria-autocomplete', 'list');
    var body = panel.querySelector('.qs__body');
    var timer = null, ctrl = null, active = -1;

    function close() { panel.classList.remove('is-open'); input.setAttribute('aria-expanded', 'false'); active = -1; }
    function open() { panel.classList.add('is-open'); input.setAttribute('aria-expanded', 'true'); }
    function hl(text, q) {
      var safe = esc(text);
      var words = q.trim().split(/\s+/).filter(function (w) { return w.length > 1; }).map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
      if (!words.length) return safe;
      return safe.replace(new RegExp('(' + words.join('|') + ')', 'gi'), '<mark>$1</mark>');
    }
    function render(data, q) {
      var res = (data && data.resources && data.resources.results) || {};
      var prods = res.products || [], cols = res.collections || [];
      var html = '';
      if (cols.length) html += '<div class="qs__cols">' + cols.slice(0, 4).map(function (c) { return '<a href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; }).join('') + '</div>';
      if (prods.length) {
        html += '<ul class="qs__list" role="listbox">' + prods.map(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          var was = p.compare_at_price_max && parseFloat(p.compare_at_price_max) > parseFloat(p.price) ? '<s>' + money(p.compare_at_price_max) + '</s>' : '';
          return '<li class="qs__item" role="option"><a href="' + esc(p.url) + '">' +
            (img ? '<img src="' + esc(small(img, 120)) + '" alt="" loading="lazy" width="52" height="52">' : '<span class="qs__ph"></span>') +
            '<span class="qs__t">' + hl(p.title, q) + '</span><span class="qs__p">' + was + money(p.price) + '</span></a></li>';
        }).join('') + '</ul>';
        html += '<a class="qs__all" href="' + form.action + '?type=product&q=' + encodeURIComponent(q) + '">Voir tous les résultats pour « ' + esc(q) + ' »</a>';
      } else if (!cols.length) {
        html = '<p class="qs__empty">Aucun produit trouvé pour « ' + esc(q) + ' ». Essayez un autre mot, par exemple « laisse » ou « gamelle ».</p>';
      }
      body.innerHTML = html; active = -1; open();
    }
    function search() {
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      if (ctrl && ctrl.abort) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      panel.classList.add('is-loading'); open();
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last', ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (d) { panel.classList.remove('is-loading'); render(d, q); })
        .catch(function (e) { if (e.name !== 'AbortError') panel.classList.remove('is-loading'); });
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(search, 220); });
    input.addEventListener('focus', function () { if (body.innerHTML && input.value.trim().length > 1) open(); });
    input.addEventListener('keydown', function (e) {
      var links = panel.querySelectorAll('.qs__item a');
      if (e.key === 'Escape') { close(); return; }
      if (!links.length || !panel.classList.contains('is-open')) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        active = (active + (e.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length;
        links.forEach(function (l, i) { l.classList.toggle('is-active', i === active); });
      } else if (e.key === 'Enter' && active >= 0) { e.preventDefault(); links[active].click(); }
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
  });

  /* ---------- Suggestions « Vous aimerez aussi » ---------- */
  var recos = document.querySelector('[data-recos]');
  if (recos) {
    var load = function () {
      fetch(recos.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var sec = tmp.querySelector('.recos');
        if (sec) recos.appendChild(sec);
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var rio = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { rio.disconnect(); load(); } }, { rootMargin: '400px' });
      rio.observe(recos);
    } else load();
  }

  /* ---------- Articles vus récemment ---------- */
  var KEY = 'zooco_vus';
  function readRv() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function writeRv(list) { try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12))); } catch (e) {} }
  var cur = document.querySelector('script[data-rv-product]');
  var current = null;
  if (cur) {
    try { current = JSON.parse(cur.textContent); } catch (e) {}
    if (current && current.url) {
      var list = readRv().filter(function (p) { return p.url !== current.url; });
      list.unshift(current); writeRv(list);
    }
  }
  document.querySelectorAll('[data-rv]').forEach(function (box) {
    var items = readRv().filter(function (p) { return !current || p.url !== current.url; }).slice(0, 10);
    if (!items.length) return;
    box.innerHTML = '<section class="rv" aria-labelledby="rv-title"><div class="rv__head"><h2 id="rv-title">Vus récemment</h2><button type="button" class="rv__clear">Effacer</button></div><ul class="rv__list">' +
      items.map(function (p) {
        return '<li><a href="' + esc(p.url) + '">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="180" height="180">' : '') + '<span>' + esc(p.title) + '</span><b>' + esc(p.price) + '</b></a></li>';
      }).join('') + '</ul></section>';
    box.querySelector('.rv__clear').addEventListener('click', function () { writeRv([]); box.innerHTML = ''; });
  });

  /* ---------- Rayons : bouton « Voir plus de produits » ---------- */
  var pag = document.querySelector('.pagination');
  var grid = document.querySelector('.grid[data-reveal]');
  var nextLink = pag && pag.querySelector('.next a, a[rel="next"]');
  if (pag && grid && nextLink) {
    var totalMatch = (document.querySelector('.toolbar .count') || {}).textContent;
    var total = totalMatch ? parseInt(totalMatch, 10) : 0;
    var wrapMore = document.createElement('div');
    wrapMore.className = 'more-wrap';
    wrapMore.innerHTML = '<p class="more-count"></p><div class="more-bar"><span></span></div><button type="button" class="btn btn-cta more-btn">Voir plus de produits</button>';
    pag.parentNode.insertBefore(wrapMore, pag);
    pag.hidden = true;
    var btn = wrapMore.querySelector('.more-btn');
    var countEl = wrapMore.querySelector('.more-count');
    var bar = wrapMore.querySelector('.more-bar span');
    var url = nextLink.href;
    var paint = function () {
      var n = grid.querySelectorAll('.card').length;
      if (total) { countEl.textContent = 'Vous avez vu ' + n + ' produits sur ' + total; bar.style.width = Math.min(100, n / total * 100) + '%'; }
    };
    paint();
    btn.addEventListener('click', function () {
      if (!url) return;
      btn.disabled = true; btn.classList.add('is-loading');
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('.grid[data-reveal] .card');
        cards.forEach(function (c, i) {
          c.style.transitionDelay = '0ms';
          c.classList.add('just-in'); c.style.animationDelay = Math.min(i, 12) * 40 + 'ms';
          grid.appendChild(document.importNode(c, true));
        });
        var nx = doc.querySelector('.pagination .next a, .pagination a[rel="next"]');
        url = nx ? nx.href : null;
        paint();
        btn.disabled = false; btn.classList.remove('is-loading');
        if (!url) { btn.remove(); }
      }).catch(function () { btn.disabled = false; btn.classList.remove('is-loading'); pag.hidden = false; });
    });
  }
})();
